import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    background-color: ${vars.colorDark};
    color: ${vars.colorTextWhite};

    .hero-header {
        display: flex;
        flex-flow: column wrap;
        place-content: center;
        place-items: center;
        padding: 8em 4em;
        gap: 2em;

        .hero-header-headline {
            font-size: 4em;
        }

        .hero-header-subheadline {
            font-size: 1em;
        }
    }

    @media all and (max-width: ${vars.mobileM}) {
        .hero-header {
            padding: 4em 2em 6em;
            text-align: center;

            .hero-header-headline {
                line-height: 1.2;
            }
        }
    }
`;
